import React, { Component } from 'react';
import { List } from './graphql.js';
import PurchaseOrdersComponent from '../../components/PurchaseOrders';
import {
  gqlOperation,
  logError,
  parseAwsJsonInArr,
} from '../../../../common/utils';
import { clone } from 'ramda';


export default class Teams extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      modal: {
        data: {},
        opened: false,
        save: {
          enabled: false
        },
        events: []
      }  
    };
  }
  
  fetchData = () => {
    gqlOperation(List, {})
      .then(({ listMyPurchaseOrders }) => {
        this.setState(prevState => {
          const newState = clone(prevState);
          newState.modal.opened = true;
          newState.data = parseAwsJsonInArr(listMyPurchaseOrders.items, ['teams']);
          return newState;
        });
      })
      .catch(logError);
  }

  handleModalOpen = (e, item) => {}

  handleModalClose = (refreshData) => {}
  
  componentDidMount() {
    this.fetchData();
  }

  render() {
    const { modal, data } = this.state;

    return (
      <PurchaseOrdersComponent
        data={data}
        modal={modal}
        onClose={this.handleModalClose}
        onOpen={this.handleModalOpen}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/private/user/containers/PurchaseOrders/index.js